/**
 * profileWire.js - PROD-1167 (patient half). ONE PHONE NUMBER PER PATIENT.
 *
 * users.phone is the patient's one number: the verified one every text goes to. The profile's
 * identification.phone is a SERVER-OWNED mirror (the API rewrites it when the number is verified
 * and ignores a client value). A profile save therefore never carries a phone: not
 * `phone`, not `identification.phone`, not the `mobilePhone` alias. The one way to change the
 * number is the code-verified flow (POST /auth/phone/send-code then /auth/phone/verify).
 *
 * Every PUT /profile goes through profileAPI.update / updateReportingRefusal, which call this.
 * Pure: no React, no fetch. Gate: scripts/check-profile-phone-account.mjs.
 */
const PHONE_KEYS = ['phone', 'mobilePhone']

export function withoutProfilePhone(body) {
  if (!body || typeof body !== 'object' || Array.isArray(body)) return body
  const out = { ...body }
  for (const k of PHONE_KEYS) delete out[k]
  const id = out.identification
  if (id && typeof id === 'object' && !Array.isArray(id)) {
    const cleaned = { ...id }
    for (const k of PHONE_KEYS) delete cleaned[k]
    out.identification = cleaned
  }
  return out
}
